export default {"src":"/_next/static/media/icon-air-freight.92a75bab.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};